import React from "react";

import CourseCertificates from "./course-certificates";

const AddCourseCertificates = ({ id }: { id: number }) => {
  return <CourseCertificates id={id} />;
};

export default AddCourseCertificates;
